export enum AttendenceOptions {
  REMOTE = 'Remote',
  INPERSON = 'In Person',
}
export default AttendenceOptions;
